import { Component, inject, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { WorkdayGeopositionMapComponent } from '../../core/components/geoposition-map/workday-geoposition-map/workday-geoposition-map.component';

@Component({
    selector: 'geoposition-dialog',
    imports: [WorkdayGeopositionMapComponent, MatIconModule, TranslocoModule],
    templateUrl: './geoposition-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './geoposition-dialog.component.scss'
})
export class GeopositionDialogComponent {

    private dialogRef = inject(MatDialogRef<WorkdayGeopositionMapComponent>);
    
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    }

    async closeDialog() {
        this.dialogRef.close();
    }
}
